module.exports = __webpack_public_path__ + "img/image_dc_rep_mean.543ba962.png";